require('../../modules/es.array.iterator');
require('../../modules/es.object.to-string');
require('../../modules/es.set');
require('../../modules/es.string.iterator');
var path = require('../../internals/path');

module.exports = path.Set;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/set/index.js
// module id = 245
// module chunks = 0